import React from 'react';
import {Main} from '../../layouts';
import Container from '../../components/Container';
import {Box, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';

const AboutView = () => {
    return (
        <Main>
            <Container>
                <Box>
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 6}}>
                            <Box>
                                <Typography variant={'h4'} gutterBottom sx={{fontWeight: 700}}>
                                    About Us
                                </Typography>
                                <Typography component={'p'}>
                                    Formed in Austin Texas in 2008, Vampire Labs, LLC is a developer of advanced power
                                    management technology with a design focus of eliminating "Vampire Energy Loss”.
                                    <br/>
                                    <br/>
                                    We have several issued patents for technology that eliminates vampire energy loss in
                                    mobile device battery chargers, and within microprocessor cores using thread-level
                                    power gating technology.
                                    <br/>
                                    <br/>
                                    Our solutions are applicable to mobile device, consumer electronic, and high end
                                    semiconductor markets. They are developed to be cost effective to implement, with
                                    little or no user behavior change.
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid size={{xs: 12, md: 6}}>
                            <Box maxWidth={500} width={1}>
                                <Box
                                    component={'img'}
                                    src={process.env.PUBLIC_URL + '/images/austin_sunset.jpg'}
                                    width={1}
                                    height={1}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Main>
    );
};

export default AboutView;